import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//
// Testimonials
import Testimonial01 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-01.png";
import Testimonial02 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-02.png";
import Testimonial03 from "./../assets/AyurvedaAssets/images/testimonial/testimonial-03.png";

// Clients
import Client01 from "./../assets/AyurvedaAssets/images/client/client-01.png";
import Client02 from "./../assets/AyurvedaAssets/images/client/client-02.png";
import Client03 from "./../assets/AyurvedaAssets/images/client/client-03.png";
import Client04 from "./../assets/AyurvedaAssets/images/client/client-04.png";
import Client05 from "./../assets/AyurvedaAssets/images/client/client-05.png";

// CTA
import CTAImg from "./../assets/AyurvedaAssets/images/single-img-05.png";

// REUSABLE COMPONENTS
import ServiceListing from "./Components/ServiceList";
import ServiceBasedAppointment from "../forms/ServiceBasedAppointment";

export default function Services({ AllServicesListing }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const slider1 = useRef(null);
  const slider2 = useRef(null);
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const testimonialAvatars = [
    {
      img: Testimonial01,
      name: "Christina lois",
      role: "Chairman and founder",
    },
    { img: Testimonial02, name: "Jessica brown", role: "Founder" },
    { img: Testimonial03, name: "Kate mason", role: "Specialist" },
  ];

  const testimonialTexts = [
    "Absolutely a-m-a-z-i-n-g! I have worked with quite a few themes over the years and i have to say that themetechmount have really nailed this one!",
    "This theme feels like they tried to fit elementor into a pre-existing theme. No elementor theme builder components exist.",
    "Template options can be overridden, but that requires more dev work than expected. I would only recommend this theme if the exact template from the demo will work for you.",
  ];

  const clients = [Client01, Client02, Client03, Client04, Client05];

  return (
    <>
      <ServiceBasedAppointment AllServicesListing={AllServicesListing} />
      {/* site-main */}
      <div className="site-main">
        {/* appointment-section */}
        <section className="prt-row appointment-section01 clearfix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="appointment-mask-wrapper">
                  <div className="appointment-mask-circle">
                    <div className="appointment-mask-image-circle"></div>
                  </div>
                  {/* featured-content-box */}
                  <div className="featured-content-box mt-30">
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>
                          Continue Your Healing Journey with Ayurveda and
                          Preventive Maintenance for Your Health
                        </h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          At Bharat Dhara, we see health as a continuous cycle —
                          not just treatment when problems arise. Our 6-step
                          Ayurvedic process combines consultation, therapies,
                          herbs, lifestyle practices, and follow-ups to provide
                          preventive maintenance for your body and mind. Stay
                          balanced, avoid relapse, and nurture long-term
                          wellness.
                        </p>
                        <div className="mt-35">
                          <a
                            className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor ml-20"
                            href="contact-us.html"
                          >
                            Book Your Appointment for Next Healing Step
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* featured-content-box end */}
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="row prt-stepsbox res-991-mt-20">
                  {[
                    {
                      num: "01",
                      title: "Consultation & Diagnosis",
                      desc: "Begin with pulse, tongue, and lifestyle assessment to understand your Prakriti and current imbalances.",
                    },
                    {
                      num: "02",
                      title: "Personalized Healing Plan",
                      desc: "Receive a tailored program including therapies, diet, yoga, and herbs designed specifically for your needs.",
                    },
                    {
                      num: "03",
                      title: "Therapies & Panchakarma",
                      desc: "Experience detox and rejuvenation treatments like Abhyanga, Shirodhara, and Panchakarma therapies.",
                    },
                    {
                      num: "04",
                      title: "Supportive Herbs & Nutrition",
                      desc: "Take home prescribed Ayurvedic medicines and food guidelines to continue healing naturally.",
                    },
                    {
                      num: "05",
                      title: "Lifestyle & Self-Practice",
                      desc: "Take home prescribed Ayurvedic medicines, home therapie, routine and food guidelines to continue healing naturally.",
                    },
                    {
                      num: "06",
                      title: "Follow-Up & Ongoing Care",
                      desc: "Stay connected with your doctor via video/phone follow-ups for adjustments and long-term guidance.",
                    },
                  ].map((step, idx) => (
                    <div key={idx} className="col-lg-12 col-md-6 col-sm-12">
                      <div
                        className={`featured-content-box style1 box-${idx + 1}`}
                      >
                        <div className="featured-content">
                          <div className="featured-title">
                            <h3>
                              {step.num}. {step.title}
                            </h3>
                          </div>
                          <div className="featured-desc">
                            <p>{step.desc}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* appointment-section end */}

        <ServiceListing AllServicesListing={AllServicesListing} />

        {/* NEWER TESTIMONIAL SECTION */}
        <section className="prt-row testimonials-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonials">
                  <div className="row res-1199-align-center">
                    {/* Avatar Slider */}
                    <div className="col-lg-3 col-md-4">
                      <Slider
                        asNavFor={nav2}
                        ref={slider1}
                        slidesToShow={1}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        vertical={false}
                        arrows={false}
                        infinite={true}
                      >
                        {testimonialAvatars.map((t, idx) => (
                          <div key={idx} className="testimonial-avatar-main">
                            <div className="testimonial-avatar">
                              <div className="testimonial-img">
                                <img
                                  width="180"
                                  height="180"
                                  className="img-fluid"
                                  src={t.img}
                                  alt="testimonial"
                                />
                              </div>
                            </div>
                            <div className="testimonial-caption">
                              <h3>{t.name}</h3>
                              <p>{t.role}</p>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* Text Slider */}
                    <div className="col-lg-9 col-md-8">
                      <Slider
                        asNavFor={nav1}
                        ref={slider2}
                        arrows={false}
                        infinite={true}
                        fade={true}
                        autoplay={true}
                        autoplaySpeed={4000}
                      >
                        {testimonialTexts.map((text, idx) => (
                          <div key={idx} className="testimonials text-center">
                            <div className="testimonial-content">
                              <blockquote className="testimonial-text">
                                {text}
                              </blockquote>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>

                  {/* Clients Section */}
                  <div className="row mt-5">
                    <div className="col-xl-3 col-lg-12"></div>
                    <div className="col-xl-9 col-lg-12">
                      <div className="client-box-main d-flex flex-wrap">
                        {clients.map((c, idx) => (
                          <div key={idx} className="client-box">
                            <div className="client-thumbnail">
                              <a href="#">
                                <img
                                  width="158"
                                  height="31"
                                  className="img-fluid"
                                  src={c}
                                  alt="client"
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* End Clients */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* NEWER TESTIMONIAL SECTION */}

        {/* cta-section */}
        <section className="prt-row padding_zero-section cta-section03 animation clearfix">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="cta-content text-center">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h2 className="cta-title">Need a help</h2>
                      <h3 className="cta-titlepre">
                        Are you facing any problem in your health?
                      </h3>
                    </div>
                    <div className="cta-bnt mt-40 fadeup-amin">
                      <a
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                        href="contact-us.html"
                      >
                        Contact us now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="prt_single_image-wrapper cta-img mt-40 res-991-mt-20"
                  data-cursor-tooltip=""
                >
                  <div className="prt_single_image-wrapper">
                    <a href="team-details.html">
                      <img
                        width="1920"
                        height="400"
                        className="img-fluid"
                        src={CTAImg}
                        alt="cta"
                      />
                    </a>
                  </div>
                  <div className="prt-pfbox-overlay">
                    <div className="ctaimg-title">
                      <a href="team-details.html">
                        Meet our Bharat Dhara Privar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* cta-section end */}
      </div>
      {/* site-main end */}
    </>
  );
}
